module.exports = __webpack_public_path__ + "media/images/photo18-685de78f401b6fefcb730df9c3fb2369.png";